import React from "react";
import { Col } from "antd";

import next_arrow from "../../../assests/images/master/next-arrow.svg";

import verifiedReportIcon from "../../../assests/images/SVG/verified_report.svg";

import "./MasterCard.scss";
const MasterCard = ({
  id,
  imgSrc,
  title,
  onClickHandler,
  route,
  disable,
  childPresent,
  isVerified,
}) => {
  return (
    <Col
      xs={24}
      sm={12}
      md={8}
      lg={6}
      xl={4}
      key={id}
      onClick={() => onClickHandler(route, childPresent, id)}
      className={disable ? "pointer-disable" : "pointer master-card-col"}
    >
      <div
        className={
          disable
            ? "master-card-container master-card-container-disbale"
            : "master-card-container"
        }
      >
        {isVerified && (
          <img
            src={verifiedReportIcon}
            alt="Verified"
            className="verified-icon"
            style={{
              position: "absolute",
              top: "5px",
              left: "5px",
              width: "20px",
              height: "20px",
            }}
          />
        )}
        <div className="img-wrapper">
          <img src={imgSrc} />
        </div>
        <div className="div">
          {title}&nbsp;<img src={next_arrow} />
        </div>
      </div>
    </Col>
  );
};
export default MasterCard;
